import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const ease = [0.76, 0, 0.24, 1];

const Slide = ({ children, delay = 0, className = "" }) => (
  <span className="inline-block overflow-hidden align-bottom">
    <motion.span
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease }}
      className={`inline-block ${className}`}
    >
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const nameY = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);

  return (
    <section id="top" ref={ref} className="relative min-h-[92svh] lg:min-h-screen flex flex-col justify-end overflow-hidden pb-8 pt-24 lg:pt-0" data-testid="hero-section">
      <div className="px-5 lg:px-10 mb-10 lg:mb-16 mt-2 lg:mt-auto flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
        <div className="max-w-xl">
          <Slide delay={0.9} className="font-swash text-2xl lg:text-3xl text-[#A8512E]">
            entrepreneur × founder × quiet operator
          </Slide>
          <div className="overflow-hidden mt-4">
            <motion.p
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1.1, delay: 1.05, ease }}
              className="text-[#4A453F] text-base lg:text-lg leading-relaxed"
            >
              I move slower than the market expects — and that's exactly where the
              magic comes from. Three ventures across education, real estate and food.
              Built quietly, from Noida.
            </motion.p>
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.5, ease }}
          className="flex gap-3"
        >
          <a href="#contact" className="pill pill--solid text-base px-7 py-3" data-testid="hero-start-conversation-btn">
            Start a conversation
          </a>
          <a href="#track-record" className="pill text-base px-7 py-3" data-testid="hero-explore-ventures-link">
            Track record
          </a>
        </motion.div>
      </div>

      <motion.h1
        style={{ y: nameY }}
        className="mt-auto lg:mt-0 px-5 lg:px-10 font-giant leading-[0.85] text-[#121110] text-[14.5vw] lg:text-[15.5vw] whitespace-nowrap flex items-end gap-[2vw]"
        data-testid="hero-headline"
      >
        <Slide delay={0.15}>NAYAN</Slide>
        <span className="inline-block overflow-hidden rounded-2xl mb-[1vw]" style={{ height: "11vw", width: "8.5vw", minWidth: "60px", minHeight: "76px" }}>
          <motion.img
            initial={{ scale: 1.4, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1.4, delay: 0.7, ease }}
            src="https://customer-assets-jai6qajn.emergentagent.net/job_nayan-magic/artifacts/5ab5jyxm_Single_picture_of_this-1779351362852.png"
            alt="Nayan Verma"
            className="w-full h-full object-cover contrast-105"
            style={{ objectPosition: "50% 12%" }}
            data-testid="hero-inline-photo"
          />
        </span>
        <Slide delay={0.35}>
          V<span className="font-swash text-[#A8512E] text-[13vw] lg:text-[12.5vw]">e</span>RMA
        </Slide>
      </motion.h1>

      <div className="px-5 lg:px-10 mt-6 flex items-center justify-between text-xs uppercase tracking-[0.2em] text-[#4A453F] font-medium">
        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.9, duration: 1 }}>
          Noida, India
        </motion.span>
        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2, duration: 1 }}>
          Scroll slowly ↓
        </motion.span>
      </div>
    </section>
  );
};

export default Hero;
